import { Node, mergeAttributes } from '@tiptap/core';
import { PluginKey } from '@tiptap/pm/state';
import Suggestion from '@tiptap/suggestion';

const CodePluginKey = new PluginKey('codes');
const Code = Node.create({
  name: 'codes',
  group: 'inline',
  inline: true,
  selectable: true,
  isolating: false,
  atom: false,
  draggable: false,
  addOptions() {
    return {
      HTMLAttributes: {},
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      renderLabel({ options, node }: any) {
        return `${node.attrs.label || node.attrs.id}`;
      },
    };
  },
  addAttributes() {
    return {
      id: {
        default: null,
        parseHTML: (element) => element.getAttribute('data-id'),
        renderHTML: (attributes) => {
          if (!attributes.id) {
            return {};
          }
          return {
            'data-id': attributes.id,
          };
        },
      },
      label: {
        default: null,
        parseHTML: (element) => element.getAttribute('data-label'),
        renderHTML: (attributes) => {
          if (!attributes.label) {
            return {};
          }
          return {
            'data-label': attributes.label,
          };
        },
      },
    };
  },
  parseHTML() {
    return [
      {
        tag: `span[data-type="${this.name}"]`,
      },
    ];
  },
  renderHTML({ node, HTMLAttributes }) {
    return [
      'span',
      mergeAttributes(
        { 'data-type': this.name },
        this.options.HTMLAttributes,
        HTMLAttributes,
      ),
      this.options.renderLabel({
        options: this.options,
        node,
      }),
    ];
  },
  renderText({ node }) {
    return this.options.renderLabel({
      options: this.options,
      node,
    });
  },
  addProseMirrorPlugins() {
    return [
      Suggestion({
        editor: this.editor,
        ...this.options.suggestion,
      }),
    ];
  },
});

export { Code, CodePluginKey, Code as default };
//# sourceMappingURL=index.js.map
